// extracted by mini-css-extract-plugin
export var root = "blog-post-preview-list-module--root--1RAME";
export var headline = "blog-post-preview-list-module--headline--1pEAK";
export var grid = "blog-post-preview-list-module--grid--h-N_-";
export var browseMoreNav = "blog-post-preview-list-module--browseMoreNav--JO6n2 typography-module--small--2jpCI";